// 视频保护 mixin - 禁用video标签的右键菜单和长按菜单
export const videoProtectionMixin = {
  data() {
    return {
      touchTimer: null,
      isLongPress: false
    };
  },

  mounted() {
    // 组件挂载后检查video标签
    this.disableVideoContextMenu();
  },

  updated() {
    // 内容更新后重新处理video标签
    this.disableVideoContextMenu();
  },

  beforeDestroy() {
    // 组件销毁前清理事件监听器
    this.cleanupVideoEventListeners();
  },

  methods: {
    /**
     * 禁用容器内所有video标签的右键菜单和长按菜单
     * @param {boolean} includeMobile - 是否包含移动端长按事件处理，默认自动检测
     */
    disableVideoContextMenu(includeMobile = this.isMobileDevice()) {
      const container = this.$refs.contentContainer;
      if (!container) return;

      // 查找所有video标签
      const videoElements = container.querySelectorAll("video");
      videoElements.forEach(video => {
        // 移除之前可能绑定的事件监听器，避免重复绑定
        this.cleanupVideoEventListener(video);

        // 添加右键菜单禁用事件（PC端和移动端都需要）
        video.addEventListener("contextmenu", this.preventContextMenu);

        // 移动端使用更精确的长按检测
        if (includeMobile) {
          video.addEventListener(
            "touchstart",
            this.handleTouchStart.bind(this)
          );
          video.addEventListener("touchend", this.handleTouchEnd.bind(this));
          video.addEventListener("touchcancel", this.handleTouchEnd.bind(this));
          video.addEventListener("touchmove", this.handleTouchEnd.bind(this));
        }
      });
    },

    /**
     * 清理单个video元素的事件监听器
     * @param {HTMLVideoElement} video - video元素
     */
    cleanupVideoEventListener(video) {
      video.removeEventListener("contextmenu", this.preventContextMenu);
      video.removeEventListener("touchstart", this.handleTouchStart);
      video.removeEventListener("touchend", this.handleTouchEnd);
      video.removeEventListener("touchcancel", this.handleTouchEnd);
      video.removeEventListener("touchmove", this.handleTouchEnd);
    },

    /**
     * 清理容器内所有video元素的事件监听器
     */
    cleanupVideoEventListeners() {
      const container = this.$refs.contentContainer;
      if (!container) return;

      const videoElements = container.querySelectorAll("video");
      videoElements.forEach(video => {
        this.cleanupVideoEventListener(video);
      });
    },

    /**
     * 处理触摸开始事件
     * @param {TouchEvent} event - 触摸事件
     */
    handleTouchStart(event) {
      this.isLongPress = false;
      // 设置长按定时器（500ms后认为是长按）
      this.touchTimer = setTimeout(() => {
        this.isLongPress = true;
        // 长按时阻止默认行为（如选择文本、弹出菜单等）
        event.preventDefault();
        return false;
      }, 500);
    },

    /**
     * 处理触摸结束事件
     * @param {TouchEvent} event - 触摸事件
     */
    handleTouchEnd(event) {
      // 清除长按定时器
      if (this.touchTimer) {
        clearTimeout(this.touchTimer);
        this.touchTimer = null;
      }

      // 如果是长按，阻止后续事件
      if (this.isLongPress) {
        event.preventDefault();
        return false;
      }

      // 重置长按状态
      this.isLongPress = false;
    },

    /**
     * 阻止右键菜单弹出
     * @param {Event} event - 事件对象
     */
    preventContextMenu(event) {
      event.preventDefault();
      return false;
    },

    /**
     * 检测是否为移动设备
     * @returns {boolean} 是否为移动设备
     */
    isMobileDevice() {
      // 检查是否为移动设备或WAP组件
      return (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        ) || this.$route?.path?.includes("/wap/")
      );
    },

    /**
     * 为内容更新后处理video标签提供便捷方法
     * 建议在接收到新内容后调用
     */
    handleContentUpdate() {
      this.$nextTick(() => {
        this.disableVideoContextMenu();
      });
    }
  }
};
